import { render, staticRenderFns } from "./HLSimpleDetail.vue?vue&type=template&id=43d6fdec&scoped=true"
import script from "./HLSimpleDetail.vue?vue&type=script&lang=js"
export * from "./HLSimpleDetail.vue?vue&type=script&lang=js"
import style0 from "./HLSimpleDetail.vue?vue&type=style&index=0&id=43d6fdec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d6fdec",
  null
  
)

export default component.exports